import { jsx as _jsx } from "react/jsx-runtime";
import ErrorMessage from '@jetbrains/ring-ui/components/error-message/error-message';
import searchIcon from '@jetbrains/icons/search';
import NavigationLink from '../navigation/navigation-link';
import styles from './not-found-error.css';
export default function NotFoundError({ fallbackHref, fallbackMessage, ...restProps }) {
    return (_jsx(ErrorMessage, { icon: searchIcon, className: styles.error, code: "Error", ...restProps, children: _jsx(NavigationLink, { "data-test": "error-message-navigation-fallback", href: fallbackHref, children: fallbackMessage }) }));
}
